/* Archivo, Latin only. font-display: optional with the preload the prerender adds: the first paint is in Archivo or,
   on a slow first visit, stays in the fallback for that view. No swap, so no layout shift. */
@font-face {
  font-family: 'Archivo Variable';
  font-style: normal;
  font-display: optional;
  font-weight: 100 900;
  font-stretch: 62% 125%;
  src: url(../../node_modules/@fontsource-variable/archivo/files/archivo-latin-standard-normal.woff2) format('woff2-variations');
  unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;
}
